<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">Jobs</h1>
      </template>
    </page-header>

    <div class="card mb-5">
      <div class="loading-overlay" v-if="loading"></div>
      <div class="card-header">
        <datepicker-input
          :value="form.date"
          @input="setDate"
          label="Date"
          :stacked="true"
        ></datepicker-input>
      </div>

      <div class="list-group text-center" v-if="run">
        <div class="row pt-2">
          <div class="col-md-4">
            <strong>Total Mileage:</strong><br />{{ run.total_mileage }}
          </div>
          <div class="col-md-4">
            <strong>Driver Hours:</strong><br />{{ run.driver_hours }}
          </div>
          <div class="col-md-4">
            <strong>Total Hours:</strong><br />{{ run.total_hours }}
          </div>
          <div class="col-12 depot-info">
            <strong>Depot Instruction:</strong><br />
            {{ run.depot_instructions || 'None provided' }}
          </div>
          <div class="col-12 text-center pb-3 pl-3 pr-3">
            <form-button
              :indicator="downloading"
              @clicked="download"
              :small="true"
            >
              Download Front Sheet
            </form-button>
          </div>
        </div>
        <div
          class="list-group-item list-group-item-action"
          :key="index"
          v-for="(item, index) in incompleteItems"
          @click="viewItem(item)"
        >
          <run-item-details :item="item"></run-item-details>
        </div>
      </div>

      <div class="list-group text-center" v-else>
        <div class="list-group-item">
          You don't have any jobs assigned for that date.
        </div>
      </div>
    </div>

    <template v-if="completedItems.length">
      <h3>Completed Jobs</h3>

      <div class="card mb-3">
        <div class="list-group text-center" v-if="run">
          <div
            class="list-group-item list-group-item-action"
            :key="index"
            v-for="(item, index) in completedItems"
            @click="viewItem(item)"
          >
            <run-item-details :item="item"></run-item-details>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import RunItemDetails from '@/components/Modules/Shared/RunItemDetails';
import PageHeader from './../Modules/Shared/PageHeader.vue';

export default {
  components: {
    RunItemDetails,
    PageHeader
  },

  data() {
    return {
      form: new window.Form({
        date: new Date()
      }),
      run: undefined,
      loading: true,
      downloading: false
    };
  },

  computed: {
    incompleteItems() {
      return this.run?.items.filter(item => !item.completed_at) || [];
    },

    completedItems() {
      return this.run?.items.filter(item => item.completed_at) || [];
    },

    user() {
      return this.$store.getters.user;
    }
  },

  mounted() {
    this.findRun();
  },

  methods: {
    findRun() {
      this.loading = true;

      const date = window.DateManager.format(this.form.date, 'YYYY-MM-DD');

      window.Ajax.get(
        `/runs?filter[driver_id]=${this.user.id}&filter[date]=${date}`
      )
        .then(({ data }) => {
          this.run = data.length ? data[0] : undefined;
          this.loading = false;
        })
        .catch(() => {
          window.toastify.error(
            'Error',
            'An error occurred loading your jobs for that date'
          );

          this.loading = false;
        });
    },

    setDate(date) {
      this.form.date = date;

      this.findRun();
    },

    jobLabelClass(job) {
      switch (job.type?.name) {
        case 'hire_delivery':
        case 'client_delivery':
          return 'label-primary';

        default:
          return 'label-warning';
      }
    },

    viewItem(item) {
      this.route(`runs/${this.run.identifier}/items/${item.identifier}`);
    },

    download() {
      if (this.run) {
        this.downloading = true;

        window.Ajax.download(`/runs/${this.run.identifier}/download`)
          .then(() => {
            this.downloading = false;
          })
          .catch(() => {
            this.downloading = false;

            window.toastify.error(
              'Error',
              'An error occurred while downloading the front sheet'
            );
          });
      }
    }
  }
};
</script>
<style>
.depot-info {
  margin: 7px;
}
</style>
